// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table#Table {
    border: none;
    border-collapse: collapse;
    width: 100%;
}


  .dashboard-content-analysis{
    width: 90%;
    background-color: white;
    padding: 65px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-height: 80vh;
    overflow-y: auto;
    ALIGN-ITEMS: end;

  }

tr#Table_headings {
    height: 61px;

    background-color: #A14B51;
    border: none;

    margin-top: 20.31px;

    font-family: 'Jost';
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    letter-spacing: 0.09px;
    line-height: 15px;
}


th.Table_heading {
    cursor: pointer;
    border: none;
    text-align: left;
    padding-left: 20px;
    padding-right: 20px;
}

.Table_heading_title {
    margin-right: 10px;
}

.Table_heading_image {
    height: 12.81px;
    width: 9.15px;

    vertical-align: middle;
}

.Table_row {
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #DCDCDC;
    height: 45px;
}

.Table_row_last {
    border-bottom: 0px;
}

.Table_values {
    font-family: "Jost";
    font-size: 14px;
    padding-left: 20px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 500;
    letter-spacing: 0;
    line-height: 24px;

}


.Table_values_link {
    text-decoration: underline;
}

.AL_Table_values_rightarrow {
    height: 11px;
    margin-left: 5px;
    vertical-align: middle;
}

.Table_values_ellipsis {
    height: 3.66px;
    width: 18.3px;
    cursor: pointer;
    margin-left: 12px;
}

.Table_values_avatar {
    height: 28px;
    width: 27.59px;
    border-radius: 28px;
    vertical-align: middle;
    margin-right: 7.41px;
}

.Rightarrow_without_link {
    padding-left: 5px;
}

.Avatar_table_value {
    cursor: pointer;
    display: flex;
}


.AL_Tooltip_icon {
    
    cursor: pointer;
    overflow: scroll;
}

.AL_Tooltip {
    vertical-align: middle;
    width: 143px;
}


.AL_Tooltip_content {
    box-sizing: border-box;
    height: 85.31px;
    width: 162px;
    border: 0.5px solid #DDDDDD;
    border-radius: 5px;
    background-color: #FFFFFF;
    box-shadow: 0 12px 27px 0 rgba(0, 0, 0, 0.28);
    position: absolute;
    margin-top: 0;
    padding-top: 0;
    left: -145px;
    top:40px;

}

.AL_T_rights {
    margin-top: 6px;
}

.AL_Tooltip_content::before,
.Action_tooltip_AD::before {
    content: '';
    border: 10px solid transparent;
    border-bottom-color: #FFFFFF;
}

.AL_Tooltip_content::after,
.AL_Tooltip_content::before {
    transform: translateX(0%) translateY(-100%) scale(1);
    transform-origin: bottom center;
    position: absolute;
    right: 9%;
}


.AL_Tooltip_content>div {
    padding: 11px 0 12.31px 22px;
    text-align: left;
    color: rgba(0, 0, 0, 0.6);
    font-family: 'Jost';
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
}

hr{
    margin: 0 0 0 11px;
    box-sizing: border-box;
    height: 1px;
    width: 142px;
    border: 1px solid #E4E4E4;
    padding :0;
}


.Action_tooltip_AD {
    box-sizing: border-box;
    /* width: 162px; */
    background-color: #FFFFFF;
    box-shadow: 0 12px 27px 0 rgba(0, 0, 0, 0.28);
    z-index: 100;
    border-radius: 5px;
    margin-top: 28px;
    right: 3.5vw;

    visibility: hidden;
    opacity: 0;
    margin-right: 0;
    position: absolute;
    cursor: pointer;

}


.Action_tooltip_AD::after,
.Action_tooltip_AD::before {
    transform: translateX(90%) translateY(-100%) scale(1);
    transform-origin: bottom center;
    position: absolute;
    right: 25%
}

.Action_tooltip_AD>div {
    color: #000000;
    font-family: 'Jost';
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 20px;
    padding: 17px 0 15px 21px;
}

.Action_tooltip_AD div~div {
    padding: 14px 0 15px 20px;
}

.Action_tooltip_AD div img {
    position: absolute;
    right: 21px;
    padding-top: 5px;
}


#tablefooter {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 68px;
    background-color: #A14B51 !important;

    margin-top: 20px;
    padding-left: 15px;
    padding-right: 33px;
}

.tablefooter_col {
    display: flex;
    align-items: center;
}

.tablefooter_col#col1 {
    font-family: 'Jost';
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
    color: #FFFFFF;
}

.tablefooter_col#col2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #FFFFFF;

}

#col2_lefttext {
    font-family: 'Jost';
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
    opacity: 50%;
}

#col2_dropdowncontainer {
    position: relative;
    cursor: pointer;
    color: #000000;
}

#col2_dropdownselected {
    box-sizing: border-box;
    height: 35.58px;
    width: 49.81px;
    background-color: #FFFFFF;

    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding: 5px;
    color: #000000;


}

#dropdown-pagenumber {
    font-family: 'Jost';
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
}

#dropdown-arrow {
    width: 9px;
}

#col2_dropdownoptions.show {
    box-sizing: border-box;
    position: absolute;
    z-index: 1;
    height: 40px;
    width: 49.81px;
    overflow-y: scroll;

    left: 10px;
    padding-left: 14px;

    background-color: #FFF;
    box-shadow: 0 20px 30px 0 rgba(0, 0, 0, 0.26);
}

#col2_dropdownoptions.show::-webkit-scrollbar {
    width: 5px;
}

#col2_dropdownoptions.show::-webkit-scrollbar-track {
    background: #f1f1f1;
}

#col2_dropdownoptions.show::-webkit-scrollbar-thumb {
    background: #888;
}

#col2_dropdownoptions.show::-webkit-scrollbar-thumb:hover {
    background: #555;
}

#col2_dropdownoptions.hide {
    display: none;
}

#dropdownoption {
    width: 15px;
    height: 20px;

    font-family: 'Jost';
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

    margin-top: 5px;
}


#col2_righttext {
    font-family: 'Jost';
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
    margin-left: 10px;
}

.tablefooter_button {
    background-color: #FFF;
    height: 35.58px;
    width: 99.62px;

    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.tablefooter_button-hide {
    display: none;
}

.tablefooter_buttonicon {
    height: 10px;
}

.tablefooter_buttonicon#leftarrow {
    transform: scaleX(-1);
}

.tablefooter_buttontitle {
    font-family: 'Jost';
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
}

.tablefooter_buttontitle#previous {
    margin-left: 5px;
}

.tablefooter_button#button2 {
    margin-left: 10px;
}

.tablefooter_buttonicon#rightarrow {
    margin-left: 5px;
}
.AL_Tooltip_icon.AL_Tooltip_content.AL_T_rights{
    width: auto !important;
    height: auto !important;
}

.Table_values_initial_circle {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #9ea6ae;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    margin-right: 10px;
    display: flex;
    

  }
  


`, "",{"version":3,"sources":["webpack://./src/screens/Projects/Analysis/Analysis.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAyB;IACzB,WAAW;AACf;;;EAGE;IACE,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;;EAElB;;AAEF;IACI,YAAY;;IAEZ,yBAAyB;IACzB,YAAY;;IAEZ,mBAAmB;;IAEnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,iBAAiB;AACrB;;;AAGA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;;IAEb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;;AAErB;;;AAGA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;;AAGA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;;AAGA;IACI,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,yBAAyB;IACzB,6CAA6C;IAC7C,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,QAAQ;;AAEZ;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;;IAEI,oDAAoD;IACpD,+BAA+B;IAC/B,kBAAkB;IAClB,SAAS;AACb;;;AAGA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,UAAU;AACd;;;AAGA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,6CAA6C;IAC7C,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;;IAEZ,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,eAAe;;AAEnB;;;AAGA;;IAEI,qDAAqD;IACrD,+BAA+B;IAC/B,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,oCAAoC;;IAEpC,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;;AAElB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,yBAAyB;;IAEzB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,cAAc;;;AAGlB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,kBAAkB;;IAElB,UAAU;IACV,kBAAkB;;IAElB,sBAAsB;IACtB,6CAA6C;AACjD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;;IAEjB,eAAe;AACnB;;;AAGA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;;IAEd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;;;EAGf","sourcesContent":["table#Table {\n    border: none;\n    border-collapse: collapse;\n    width: 100%;\n}\n\n\n  .dashboard-content-analysis{\n    width: 90%;\n    background-color: white;\n    padding: 65px;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    max-height: 80vh;\n    overflow-y: auto;\n    ALIGN-ITEMS: end;\n\n  }\n\ntr#Table_headings {\n    height: 61px;\n\n    background-color: #A14B51;\n    border: none;\n\n    margin-top: 20.31px;\n\n    font-family: 'Jost';\n    font-size: 14px;\n    font-weight: 500;\n    color: #FFFFFF;\n    letter-spacing: 0.09px;\n    line-height: 15px;\n}\n\n\nth.Table_heading {\n    cursor: pointer;\n    border: none;\n    text-align: left;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.Table_heading_title {\n    margin-right: 10px;\n}\n\n.Table_heading_image {\n    height: 12.81px;\n    width: 9.15px;\n\n    vertical-align: middle;\n}\n\n.Table_row {\n    padding-top: 20px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #DCDCDC;\n    height: 45px;\n}\n\n.Table_row_last {\n    border-bottom: 0px;\n}\n\n.Table_values {\n    font-family: \"Jost\";\n    font-size: 14px;\n    padding-left: 20px;\n    color: rgba(0, 0, 0, 0.8);\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 24px;\n\n}\n\n\n.Table_values_link {\n    text-decoration: underline;\n}\n\n.AL_Table_values_rightarrow {\n    height: 11px;\n    margin-left: 5px;\n    vertical-align: middle;\n}\n\n.Table_values_ellipsis {\n    height: 3.66px;\n    width: 18.3px;\n    cursor: pointer;\n    margin-left: 12px;\n}\n\n.Table_values_avatar {\n    height: 28px;\n    width: 27.59px;\n    border-radius: 28px;\n    vertical-align: middle;\n    margin-right: 7.41px;\n}\n\n.Rightarrow_without_link {\n    padding-left: 5px;\n}\n\n.Avatar_table_value {\n    cursor: pointer;\n    display: flex;\n}\n\n\n.AL_Tooltip_icon {\n    \n    cursor: pointer;\n    overflow: scroll;\n}\n\n.AL_Tooltip {\n    vertical-align: middle;\n    width: 143px;\n}\n\n\n.AL_Tooltip_content {\n    box-sizing: border-box;\n    height: 85.31px;\n    width: 162px;\n    border: 0.5px solid #DDDDDD;\n    border-radius: 5px;\n    background-color: #FFFFFF;\n    box-shadow: 0 12px 27px 0 rgba(0, 0, 0, 0.28);\n    position: absolute;\n    margin-top: 0;\n    padding-top: 0;\n    left: -145px;\n    top:40px;\n\n}\n\n.AL_T_rights {\n    margin-top: 6px;\n}\n\n.AL_Tooltip_content::before,\n.Action_tooltip_AD::before {\n    content: '';\n    border: 10px solid transparent;\n    border-bottom-color: #FFFFFF;\n}\n\n.AL_Tooltip_content::after,\n.AL_Tooltip_content::before {\n    transform: translateX(0%) translateY(-100%) scale(1);\n    transform-origin: bottom center;\n    position: absolute;\n    right: 9%;\n}\n\n\n.AL_Tooltip_content>div {\n    padding: 11px 0 12.31px 22px;\n    text-align: left;\n    color: rgba(0, 0, 0, 0.6);\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 18px;\n}\n\nhr{\n    margin: 0 0 0 11px;\n    box-sizing: border-box;\n    height: 1px;\n    width: 142px;\n    border: 1px solid #E4E4E4;\n    padding :0;\n}\n\n\n.Action_tooltip_AD {\n    box-sizing: border-box;\n    /* width: 162px; */\n    background-color: #FFFFFF;\n    box-shadow: 0 12px 27px 0 rgba(0, 0, 0, 0.28);\n    z-index: 100;\n    border-radius: 5px;\n    margin-top: 28px;\n    right: 3.5vw;\n\n    visibility: hidden;\n    opacity: 0;\n    margin-right: 0;\n    position: absolute;\n    cursor: pointer;\n\n}\n\n\n.Action_tooltip_AD::after,\n.Action_tooltip_AD::before {\n    transform: translateX(90%) translateY(-100%) scale(1);\n    transform-origin: bottom center;\n    position: absolute;\n    right: 25%\n}\n\n.Action_tooltip_AD>div {\n    color: #000000;\n    font-family: 'Jost';\n    font-size: 14px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 20px;\n    padding: 17px 0 15px 21px;\n}\n\n.Action_tooltip_AD div~div {\n    padding: 14px 0 15px 20px;\n}\n\n.Action_tooltip_AD div img {\n    position: absolute;\n    right: 21px;\n    padding-top: 5px;\n}\n\n\n#tablefooter {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    height: 68px;\n    background-color: #A14B51 !important;\n\n    margin-top: 20px;\n    padding-left: 15px;\n    padding-right: 33px;\n}\n\n.tablefooter_col {\n    display: flex;\n    align-items: center;\n}\n\n.tablefooter_col#col1 {\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 18px;\n    color: #FFFFFF;\n}\n\n.tablefooter_col#col2 {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    color: #FFFFFF;\n\n}\n\n#col2_lefttext {\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 18px;\n    opacity: 50%;\n}\n\n#col2_dropdowncontainer {\n    position: relative;\n    cursor: pointer;\n    color: #000000;\n}\n\n#col2_dropdownselected {\n    box-sizing: border-box;\n    height: 35.58px;\n    width: 49.81px;\n    background-color: #FFFFFF;\n\n    margin-left: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    padding: 5px;\n    color: #000000;\n\n\n}\n\n#dropdown-pagenumber {\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 18px;\n}\n\n#dropdown-arrow {\n    width: 9px;\n}\n\n#col2_dropdownoptions.show {\n    box-sizing: border-box;\n    position: absolute;\n    z-index: 1;\n    height: 40px;\n    width: 49.81px;\n    overflow-y: scroll;\n\n    left: 10px;\n    padding-left: 14px;\n\n    background-color: #FFF;\n    box-shadow: 0 20px 30px 0 rgba(0, 0, 0, 0.26);\n}\n\n#col2_dropdownoptions.show::-webkit-scrollbar {\n    width: 5px;\n}\n\n#col2_dropdownoptions.show::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n#col2_dropdownoptions.show::-webkit-scrollbar-thumb {\n    background: #888;\n}\n\n#col2_dropdownoptions.show::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n#col2_dropdownoptions.hide {\n    display: none;\n}\n\n#dropdownoption {\n    width: 15px;\n    height: 20px;\n\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 18px;\n\n    margin-top: 5px;\n}\n\n\n#col2_righttext {\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 18px;\n    margin-left: 10px;\n}\n\n.tablefooter_button {\n    background-color: #FFF;\n    height: 35.58px;\n    width: 99.62px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.tablefooter_button-hide {\n    display: none;\n}\n\n.tablefooter_buttonicon {\n    height: 10px;\n}\n\n.tablefooter_buttonicon#leftarrow {\n    transform: scaleX(-1);\n}\n\n.tablefooter_buttontitle {\n    font-family: 'Jost';\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 18px;\n}\n\n.tablefooter_buttontitle#previous {\n    margin-left: 5px;\n}\n\n.tablefooter_button#button2 {\n    margin-left: 10px;\n}\n\n.tablefooter_buttonicon#rightarrow {\n    margin-left: 5px;\n}\n.AL_Tooltip_icon.AL_Tooltip_content.AL_T_rights{\n    width: auto !important;\n    height: auto !important;\n}\n\n.Table_values_initial_circle {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    background-color: #9ea6ae;\n    color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    font-weight: bold;\n    margin-right: 10px;\n    display: flex;\n    \n\n  }\n  \n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
